<template>
  <li v-on:click="select" class="z-depth-3 proposal">{{title}}</li>
</template>

<script>
export default {
  props: ["title"],
  methods: {
    select: function() {
      this.$emit("select", this.title);
    }
  }
};
</script>

<style scoped>
.proposal {
  border: 1px solid #484f54;
  padding: 0.5em 0.4em;
  margin-top: 0.5em;
}
</style>
